import { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import { RouteConstants } from '../../routes';
import SettingsPage from './pages/SettingsPage/SettingsPage';

interface IProps {}

const Settings: FC<IProps> = props => {
  return (
    <Switch>
      <Route path={RouteConstants.settings.index} component={SettingsPage} />
    </Switch>
  );
};

export default Settings;
